import type { useAuth0 } from '@auth0/auth0-react';

type Auth0ClientSubset = ReturnType<typeof useAuth0>;

export let auth0Client: Auth0ClientSubset;
export const setAuth0Client = (client: Auth0ClientSubset) => {
  auth0Client = client;
  return client;
};
